import React, { Component } from "react";
import { GetCookieFunction } from '../../utils/util';

const FUNNEL_STEPS = [
    { label: "Personal Profile", path: "editProfile", clinical: false, doctorOnly: false },
    { label: "Patient Info", path: "patientInfo", clinical: false, doctorOnly: false },
    { label: "Past Medical History", path: "pastMedicalHistory", clinical: true, doctorOnly: false },
    { label: "Family & Social History", path: "familySocialHistory", clinical: true, doctorOnly: false },
    { label: "Review of Systems", path: "reviewSystems", clinical: true, doctorOnly: false },
    { label: "Allergies", path: "allergies", clinical: true, doctorOnly: false },
    { label: "Medications", path: "medications", clinical: true, doctorOnly: false },
    { label: "Surgical History", path: "surgeries", clinical: true, doctorOnly: false },
    { label: "Assessment & Plan", path: "assessmentPlan", clinical: true, doctorOnly: false },
    { label: "Dialysis Order", path: "dialysisorder", clinical: true, doctorOnly: true },
];

class FunnelNav extends Component {
    constructor(props) {
        super(props);
        this.state = { dropdownOpen: false };
    }

    navigate = (stepIndex) => {
        const step = FUNNEL_STEPS[stepIndex];
        window.location.href = `/patients/${this.props.patientId}/${step.path}?funnel=1`;
    }

    render() {
        const { currentStep } = this.props;
        const userType = GetCookieFunction("User").type;
        const isClinical = userType === "doctor" || userType === "nurse";
        const isDoctor = userType === "doctor";
        const visibleSteps = FUNNEL_STEPS.filter(step => 
            (!step.clinical || isClinical) && (!step.doctorOnly || isDoctor)
        );
        const total = visibleSteps.length;
        const currentVisibleIndex = visibleSteps.indexOf(FUNNEL_STEPS[currentStep]);
        const current = FUNNEL_STEPS[currentStep];
        const hasPrev = currentVisibleIndex > 0;
        const hasNext = currentVisibleIndex < total - 1;

        return (
            <div className="funnel-nav">
                <button
                    className="funnel-nav-arrow"
                    disabled={!hasPrev}
                    onClick={() => this.navigate(FUNNEL_STEPS.indexOf(visibleSteps[currentVisibleIndex - 1]))}
                    title={hasPrev ? visibleSteps[currentVisibleIndex - 1].label : ""}
                >←</button>

                <div className="funnel-nav-center" onClick={() => this.setState(prev => ({ dropdownOpen: !prev.dropdownOpen }))}>
                    <span className="funnel-nav-label">
                        Step {currentVisibleIndex + 1} of {total}: {current.label}
                    </span>
                    <span className="funnel-nav-caret">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="6 9 12 15 18 9"/>
                        </svg>
                    </span>

                    {this.state.dropdownOpen && (
                        <ul className="funnel-nav-dropdown">
                            {visibleSteps.map((step, i) => (
                                <li
                                    key={i}
                                    className={`funnel-nav-dropdown-item ${step === current ? 'active' : ''}`}
                                    onClick={(e) => { e.stopPropagation(); this.navigate(FUNNEL_STEPS.indexOf(step)); }}
                                >
                                    <span className="funnel-nav-step-num">{i + 1}</span>
                                    {step.label}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <button
                    className="funnel-nav-arrow"
                    disabled={!hasNext}
                    onClick={() => this.navigate(FUNNEL_STEPS.indexOf(visibleSteps[currentVisibleIndex + 1]))}
                    title={hasNext ? visibleSteps[currentVisibleIndex + 1].label : ""}
                >→</button>
            </div>
        );
    }
}

export { FunnelNav, FUNNEL_STEPS };
